<template>
  <h2 :style="titleStyle">{{ title }}</h2>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'page-title-component',
  props: {
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    titleStyle () {
      return {
        display: 'inline-block',
        lineHeight: '40px',
        marginBottom: '5px',
        color: this.theme.title_color
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PageTitle.vue